/**
 * URL base del API (Express, puerto por defecto 3505 en server/config.js).
 *
 * - Desarrollo (`npm run serve`): si no definís nada, usa http://192.168.1.182:3505
 * - Producción (`npm run build`): sin variable, usa https://api.puestify.com
 *
 * Siempre podés fijar VUE_APP_API_URL en `.env.local` o `.env.production`.
 */
const devDefault = 'http://192.168.1.182:3505';
const prodDefault = 'https://api.puestify.com';

export const API_BASE_URL =
    process.env.VUE_APP_API_URL ||
    (process.env.NODE_ENV === 'production' ? prodDefault : devDefault);

/**
 * URL pública del front donde vive cada menú (ruta `/:nombreNegocio` en el SPA;
 * el segmento es el usuario de la cuenta, igual que en el registro).
 * Producción: subdominio dedicado. En local usá `VUE_APP_PUBLIC_STORE_URL`.
 */
export const PUBLIC_STORE_BASE =
    process.env.VUE_APP_PUBLIC_STORE_URL || 'https://puestify.com';

/** URL absoluta del menú (QR, “Ver menú”, etc.). */
export function publicStoreMenuUrl(usuario) {
    if (!usuario) return '';
    const base = (PUBLIC_STORE_BASE || '').replace(/\/$/, '');
    if (!base) return `/${encodeURIComponent(usuario)}`;
    return `${base}/${encodeURIComponent(usuario)}`;
}

/** Texto sin protocolo, ej. `puestify.com/minegocio`. */
export function publicStoreDisplayPath(usuario) {
    if (!usuario) return '';
    const base = (PUBLIC_STORE_BASE || '').replace(/\/$/, '');
    let host = 'puestify.com';
    try {
        if (base) {
            const withProto = /^https?:\/\//i.test(base) ? base : `https://${base}`;
            host = new URL(withProto).hostname;
        }
    } catch {
        /* usar host por defecto */
    }
    return `${host}/${usuario}`;
}
